import { ChartOptions } from "chart.js";

export const AREA_CHART_BASE_OPTIONS: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: false,
    clip: false,
    layout: {
        autoPadding: false,
        padding: {
            top: 10,
            left: -8,
            bottom: -8,
        },
    },

    interaction: {
        intersect: false,
        mode: "nearest",
    },
    animation: false,
    scales: {
        y: {
            grid: {
                display: false,
            },
            border: {
                display: false,
            },
            ticks: {
                display: false,
            },
        },
        x: {
            grid: {
                display: false,
            },
            border: {
                display: false,
            },
            ticks: {
                display: false,
            },
        },
    },
};
